import { RewardsOptionsSize } from 'utils/constants/rewardsOptionsSize'

export const useRewardOptionsSize = (
  value: string | undefined
): string | undefined => {
  const sizeValue = RewardsOptionsSize[value as keyof typeof RewardsOptionsSize]

  return sizeValue
}
